// Route « home » d'une entité pour un utilisateur — EXTRAITE de getAllRoutes.
//
// C'était la SEULE fonction de getAllRoutes à consommer getRoutes, et getRoutes importe
// getAllRoutes : le cycle lib/routes/getAllRoutes ↔ lib/getRoutes traversait toutes les
// pages (chaque menu et chaque navigation). Ce fichier importe les deux bouts — plus de
// retour en arrière.

import getRoutes from '@/lib/getRoutes'
import getListRouteAvailable from '@/lib/routes/getAllRoutes'

export const getListRoutesHome = (loggedUserRoles, entitySelect, router = null) => {
  const listRoute = getListRouteAvailable(loggedUserRoles, entitySelect)

  if (router?.pathname && listRoute?.find(r => r?.href === router.pathname)) {
    const routeFind = listRoute?.find(r => r?.href === router.pathname)
    return getRoutes({ route: routeFind.route, values: router.query })
  }

  return listRoute?.find(r => r?.home) || listRoute?.[0]
}
